import React from 'react';
import { Grid, Box, makeStyles, Typography } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { theme } from '../../App';

const useStyles = makeStyles((theme) => ({
  container: {},
}));

const AdminIntroSection = () => {
  const store = useSelector((state) => state);
  const dispatch = useDispatch();
  const classes = useStyles();

  return (
    <Box
      textAlign='center'
      display='flex'
      flexDirection='column'
      alignItems='center'
      py='10vh'
    >
      <Typography variant='h1'>Dashboard</Typography>
      <Typography
        variant='body1'
        style={{
          maxWidth: '50%',
          marginTop: theme.spacing(2),
          marginBottom: theme.spacing(2),
        }}
      >
        Welcome to the Dashboard ! Here you will find all the Ingredients & Dish NFTs you have collected till now.
      </Typography>
    </Box>
  );
};

export default AdminIntroSection;
